import { render } from "./DeviceEditForm.vue?vue&type=template&id=580c5261"
import script from "./DeviceEditForm.vue?vue&type=script&lang=js"
export * from "./DeviceEditForm.vue?vue&type=script&lang=js"
script.render = render

export default script